/* eslint-disable max-lines */
/* eslint-disable quotes */
/***
 * Formato de literales: [pantalla]_[lineral]
 */
export const strings = {
  splash_title: "Welcome to the new EMT Palma website",
  lb_ca: "Català",
  lb_es: "Español",
  lb_en: "English",
  lb_de: "Deutsch",
  iniciar_sesion: "Log in",
  lb_aceptar: "Accept",
  lb_cancelar: "Cancel",
  lb_cerrar: "Close",
  lb_agenda: "Events calendar",
  lb_museos: "Museums",
  lb_monumentos: "Monuments",
  lb_rutas: "Routes",
  lb_bibliotecas: "Libraries",
  lb_playas: "Beaches",
  lb_centros_deportivos: "Sport centers",
  lb_centros_educativos: "Educational centers",
  lb_listado_lineas: "List of  lines",
  lb_casa: "Home",
  lb_trabajo: "Work",
  lb_colegio: "School",
  lb_deportes: "Sports",
  lb_busquedas_recientes: "Recent searches",
  lb_busquedas_recientes_msg: "Search for an address or select a point on the map to plan your route",
  lb_parada_destino: "Stop or destination",
  lb_lineas_horarios: "Lines and schedules",
  lb_lineas_horarios_bus: "Lines and bus schedules",
  lb_alteraciones_servicio: "All service disruptions",
  lb_conoce_nuestra_red_transporte: "Get to know our transport network",
  lb_paradas: "Stops",
  lb_parada: "Stop",
  lb_planificador: "Route planner",
  lb_lineas: "Lines",
  lb_tarifas_tarjetas: "Fares and Top-up",
  lb_tarifas_recarga: "Fares and Top-up",
  lb_atencion_cliente: "Customer support",
  lb_emt_palma: "EMT Palma",
  lb_visita_palma: "Visit Palma",
  lb_explorar: "Explore",
  lb_cargando: "Loading",
  lb_buscar: "Search",
  lb_novedades: "News",
  lb_borrar_parada_error_msj: "Error deleting the stop. Please try again later",
  lb_agregar_parada_error_msj: "Error adding the stop. Please try again later",
  lb_borrar_parada_exito_msj: "Stop successfully deleted",
  lb_borrar_parada_exito_msj_secundario: "You will receive alerts for this stop",
  lb_agregar_parada_exito_msj: "Stop successfully saved",
  lb_borrar_linea_error_msj: "Error deleting the line. Please try again later",
  lb_agregar_linea_error_msj: "Error adding the line. Please try again later",
  lb_borrar_linea_exito_msj: "Line successfully deleted",
  lb_borrar_linea_exito_msj_secundario: "You will receive notifications for this line when there are active alerts",
  lb_agregar_linea_exito_msj: "Line successfully added to favorites",
  lb_borrar_poi_error_msj: "Error deleting the point of interest. Please try again later",
  lb_agregar_poi_error_msj: "Error added the point of interest. Please try again later",
  lb_borrar_poi_exito_msj: "Point of interest successfully deleted",
  lb_borrar_poi_exito_msj_secundario: "You will receive alerts for this point of interest",
  lb_agregar_poi_exito_msj: "Point of interest successfully added",
  lb_borrar_destino_error_msj: "Error deleting the destination. Please try again later",
  lb_agregar_destino_error_msj: "Error adding the destination. Please try again later",
  lb_borrar_destino_exito_msj: "Destination successfully deleted",
  lb_borrar_destino_exito_msj_secundario: "You will receive alerts for this destination",
  lb_agregar_destino_exito_msj: "Destination successfully added",
  lb_borrar_evento_error_msj: "Error deleting the event. Please try again later",
  lb_agregar_evento_error_msj: "You will receive alerts for this event",
  lb_borrar_evento_exito_msj: "Error adding the event. Please try again later",
  lb_borrar_evento_exito_msj_secundario: "Event successfully deleted",
  lb_agregar_evento_exito_msj: "Event successfully added",
  lb_msj_error_generico: "Error performing the operation. Please try again later",
  lb_msj_exito_generico: "Operation successfully completed",
  lb_No_encontado: "No results found",
  lb_explorer_lugares: "EMT network POIs",
  lb_explorer_transportes: "Transports",
  lb_explorer_paradas_lineas: "Stops and lines",
  lb_explorer_filtros: "Filters",
  lb_explorer_filtros_deshacer: "Undo",
  lb_explorer_detalle_parada: "Stop details",
  lb_avisos_descargar: "Download PDF",
  lb_avisos_ampliar: "Expand",
  lb_planner_donde_quieres_ir: "Where are we going?",
  lb_planner_origen: "Origin",
  lb_planner_destino: "Destination",
  lb_planner_seleccionar_mi_localizacion: "Select my location",
  lb_planner_seleccionar_mi_posicion_mapa: "Select a location on the map",
  lb_planner_salir_en: "Depart in:",
  lb_planner_minutos: "minutes",
  lb_planner_no_especificar: "Not specified",
  lb_planner_transbordo: "Transfer",
  lb_planner_salir_ahora: "Depart now",
  lb_planner_salir_a_las: "Depart at",
  lb_planner_llegar_a_las: "Arrive at",
  lb_planner_paradas: "Stops",
  lb_planner_my_ubicacion: "My location",
  lb_planner_preferencias: "Preferences",
  lb_planner_preferencias_ordenar: "Sort by",
  lb_planner_preferencias_parametros: "Parameters",
  lb_planner_preferencias_operadores: "Operators",
  lb_planner_preferencias_parking_disuasorio: "Combine car with park-and-ride",
  lb_planner_preferencias_accesibilidad_sillas: "Wheelchair accessibility",
  lb_planner_preferencias_mas_rapida: "Faster",
  lb_planner_preferencias_menos_trans: "Fewer transfers",
  lb_planner_preferencias_caminar: "Less walking",
  lb_planner_preferencias_caminar_max: "Maximum walking",
  lb_planner_preferencias_ruta_mas_rapida: "Fastest route",
  lb_favorites_paradas_guardadas: "Saved stops",
  lb_favorites_lineas_guardadas: "Saved lines",
  lb_favorites_eventos_guardadas: "Saved events",
  lb_favorites_destinos_guardadas: "Saved destinations",
  lb_Favoritos: "Favorites",
  lb_favorites_buscar_favorito: "Search favorite",
  lb_favorites_buscar_lineas: "Search lines",
  lb_favorites_tab_paradas: "Stops",
  lb_favorites_tab_destinos: "Places",
  lb_favorites_tab_lineas: "Lines",
  lb_favorites_tab_agenda: "Events calendar",
  lb_favorites_anadir_casa: "Add home",
  lb_favorites_anadir_trabajo: "Add work",
  lb_favorites_guarda_parada: "Save a stop as favorite",
  lb_favorites_ninguna_parada: "You don’t have any saved stops yet. Add your most frequently used stops to access them quickly",
  lb_favorites_guarda_destino: "Save a place as favorite",
  lb_favorites_ningun_destino: "You don’t have any saved places yet. Add your most frequently used places to access them quickly",
  lb_favorites_guarda_linea: "Save a line as favorite",
  lb_favorites_ninguna_linea: "You don’t have any saved lines yet. Add your most frequently used lines to access them quickly",
  lb_favorites_guarda_evento: "Save an event as favorite",
  lb_favorites_ninguna_evento: "You don’t have any saved events yet. Add your most frequently used event to access them quickly",
  lb_favorites_guardar_secondary: "Please select a category and a name. If you don’t choose one, it will be saved without categorization",
  lb_favorites_guardar_parada_interrogante: "Do you want to save this stop as a favorite?",
  lb_favorites_guardar_parada_main: "It will be saved under “Saved stops” in your favorites",
  lb_favorites_guardar_linea_interrogante: "Do you want to save this line as a favorite?",
  lb_favorites_guardar_linea_main: "It will be saved under “Saved lines” in your favorites",
  lb_favorites_guardar_evento_interrogante: "Do you want to save this event as a favorite?",
  lb_favorites_guardar_evento_main: "It will be saved under “Saved events” in your favorites",
  lb_favorites_guardar_destino_interrogante: "Do you want to save this destination as a favorite?",
  lb_favorites_guardar_destino_main: "It will be saved under “Saved destinations” in your favorites",
  lb_favorites_seguro_eliminar_parada: "Are you sure you want to delete this stop?",
  lb_favorites_seguro_eliminar_line: "Are you sure you want to delete this line?",
  lb_favorites_seguro_eliminar_destino: "Are you sure you want to delete this destination?",
  lb_favorites_seguro_eliminar_evento: "Are you sure you want to delete this event?",
  lb_configuracion_menu_gestionar_cuenta: "Manage account",
  lb_configuracion_menu: "Menu",
  lb_configuracion_account: "My account",
  lb_configuracion_menu_idioma: "Language",
  lb_configuracion_menu_avisos: "Alerts",
  lb_configuracion_menu_favoritos: "Favorites",
  lb_configuracion_menu_ayuda: "Help & contact",
  lb_configuracion_parada: "Estimated arrival time",
  lb_info_contacto: "Contact EMT Palma",
  lb_oficina_atcliente_ayuntamiento_palma: "Customer Service Office of EMT Palma and Citizen Service Offices of Palma City Council",
  lb_gestiones_tarjeta_ciudadana: "For Citizen Card procedures, you can visit your nearest Citizen Service Office",
  lb_oficina_palama_oac: "EMT Palma Office or Citizen Service Office (OAC)",
  lb_configuracion_menu_tarifas: "Fares",
  lb_configuracion_menu_points: "My points",
  lb_configuracion_menu_configuracion: "Settings",
  lb_configuracion_menu_notifications: "Notifications",
  lb_configuracion_menu_terminos_privacidad: "Terms & Privacy",
  lb_configuracion_menu_aviso_legal: "Legal notice",
  lb_configuracion_menu_eliminar_datos: "Delete your data",
  lb_configuracion_recuperar_password: "Reset password",
  lb_configuracion_password: "Password",
  lb_configuracion_registrate_para_poder: "Sign up to access all features",
  lb_configuracion_crear_cuenta: "Create account",
  lb_configuracion_repetir_password: "Repeat password",
  lb_configuracion_acceptar_terminos_condiciones: "Accept terms and conditions",
  lb_configuracion_alias: "Alias",
  lb_configuracion_cerrar_sesion: "Log out",
  lb_configuracion_punto_cerrar_session: "You are about to log out",
  lb_configuracion_datos_modificados: "Data updated",
  lb_configuracion_datos_guardados: "Data successfully saved",
  lb_configuracion_cuenta_creada: "Account successfully created",
  lb_sesion_no_iniciada: "Sign up or log in to access all features",
  lb_configuracion_inicia_sesion: "Check your inbox to activate your account",
  lb_contrasena_minimo_caracteres: "Minimum 6 characters",
  lb_contrasena_minimo_una_letra: "At least one uppercase and one lowercase letter",
  lb_contrasena_minimo_un_numero: "At least one number",
  lb_ambas_contrasenas_iguales: "Passwords must match",
  lb_configuracion_datos_guardados_correctamente: "Your data has been saved successfully",
  lb_configuracion_correo: "Email address",
  lb_configuracion_informacion_personal: "Personal information",
  lb_configuracion_cambiar_contrasena: "Change password",
  lb_configuracion_nueva_contrasena: "New password",
  lb_configuracion_actual_contrasena: "Current password",
  lb_configuracion_confirmar_contrasena: "Confirm password",
  lb_configuracion_guardar_cambios: "Save changes",
  lb_configuracion_necesitas_contrasena_nueva: "Need a new password?",
  lb_configuracion_necesitas_contrasena_nueva_text: "Enter the email address you used to register",
  lb_configuracion_usuario_actualizado: "User updated successfully",
  lb_configuracion_revisa_bandeja_correo: "Check your inbox",
  lb_lineas_directorio_lineas: "Regular lines",
  lb_lineas_busca_linea: "Search for a line",
  lb_lineas_visualizar_sentido: "Would you like to view a direction?",
  lb_lineas_detalle_linea: "Line details",
  lb_lineas_tab_linea: "Line",
  lb_lineas_tab_horarios: "Schedules",
  lb_lineas_tab_avisos: "Alerts",
  lb_lineas_a_las: "at",
  lb_home_cerca_mi: "Explore",
  lb_home_avisos_alertas: "Alerts",
  lb_ver_avisos: "View alerts",
  lb_home_saber_mas: "Learn more",
  lb_home_consejos_informacion_novedades: "Tips & information",
  lb_error404_no_encontrada: "Page not found",
  lb_error500: "Unexpected error",
  lb_volver_al_home: "Go to home",
  lb_avisos: "General alerts",
  lb_mis_avisos: "My alerts",
  lb_titulo_aviso: "No active alerts at the moment",
  lb_titulo_texto_favorito: "All active alerts for the user’s favorite stops/lines will be shown",
  lb_titulo_texto: "All active alerts for EMT Palma stops and lines will be shown",
  lb_ruta_desde_esta_parada: "Route from this stop",
  lb_seo_title_inicio: "Home",
  lb_seo_default_description: "EMT Palma is the municipal company of the Palma City Council responsible for managing the city’s urban public transport network",
  lb_seo_description_inicio: "EMT Palma is the municipal company of the Palma City Council responsible for managing the city’s urban public transport network",
  lb_seo_title_planificador: "Route planner",
  lb_seo_description_planificador: "Plan your trip with EMT Palma. Check routes, schedules, and stops to reach your destination using Palma’s urban transport network",
  lb_seo_title_paradas: "Stops and points of interest",
  lb_seo_description_paradas: "Explore EMT stops, points of interest, and information offices in Palma. Quickly find your nearest stop and its connections",
  lb_seo_title_lineas: "Lines",
  lb_seo_description_lineas: "Browse all EMT Palma lines and their routes. Discover the available public transport options in Palma and nearby areas",
  lb_seo_title_tarifas: "Fares",
  lb_seo_description_tarifas: "Learn about public transport fares in Palma, including single tickets, passes with the Citizen Card, and other travel options across the city",
  lb_seo_title_puntos_venta: "Sales points",
  lb_seo_description_puntos_venta: "Find ticket sales points for public transport in Palma. See locations of ticket machines and customer service offices",
  lb_seo_title_atencion_cliente: "Customer service",
  lb_seo_description_atencion_cliente: "Find EMT Palma contact information and locate citizen service offices on the map",
  lb_seo_title_faq: "FAQ",
  lb_seo_description_faq: "Find answers to your questions in our FAQ section. Filter by category and get the information you need about public transport in Palma",
  lb_seo_title_noticias: "News",
  lb_seo_description_noticias: "Stay up to date with the latest news about public transport in Palma",
  lb_seo_title_favoritos: "Favorites",
  lb_seo_description_favoritos: "Access all the items you’ve saved as favorites: stops, points of interest, or EMT Palma lines",
  lb_seo_title_configuracion: "Settings",
  lb_seo_description_configuracion: "Customize your EMT Palma website settings. Manage your favorites and select your preferred language",
  lb_overlapping_lines_desc: "Lines passing through here",
  lb_overlapping_line1_desc: "Line passing through here",
  lb_ver_todos_itinerarios: "View all routes",
  lb_ampliar: "Expand",
  lb_noticias: "News",
  lb_noticia: "News",
  lb_noticias_novedades: "News & updates",
  lb_oficina_atcliente: "EMT Palma Customer Service Office",
  lb_horarios_atcliente: "Customer service hours",
  lb_faqs: "Frequently Asked Questions (FAQs)",
  lb_preguntas_frecuentes: "Frequently Asked Questions",
  lb_buscar_contenido: "Search content",
  lb_buscar_por_palabra_clave: "Search by keyword",
  lb_muestran_resultados_para: "Showing results for",
  lb_no_hay_coincidencias: "No matches found",
  lb_punto_recarga_venta: "Top-up & sales points",
  lb_urbano: "Urban",
  lb_aeropuerto: "Airport",
  lb_puerto: "Port",
  lb_perfil: "Profile",
  lb_gratis: "Free",
  lb_nota: "Note",
  lb_descargar_mas_informacion: "Download more information",
  lb_advertencias: "Warnings",
  lb_referencias_legales: "Legal references",
  lb_no_hay_datos_disponibles: "No data available",
  lb_ir: "Go",
  lb_favorito: "Favorite",
  lb_alarma: "Alert",
  lb_horarios: "Schedules",
  lb_refrescar: "Refresh",
  lb_accesibilidad: "Accessibility",
  lb_filtra: "Filter",
  lb_paso_por_parada: "Estimated arrival time",
  lb_maquinas_autoventas: "24h Self-Service Ticket Machine",
  lb_puntos_ventas: "Recharge and Ticket Sales Point",
  lb_oficina_emt: "Citizen Service Office",
  lb_oficina_atencion_cliente: "EMT Palma Office",
  lb_eliminar_mis_datos: "Delete my data",
  lb_cuenta_eliminada: "Account successfully deleted",
  lb_publicado_el: "Published on",
  lb_desde_el: "From:",
  lb_hasta_el: "Until:",
  lb_reclamaciones: "Claims",
  lb_reclamaciones_descripcion: "If you wish to file a claim or report any irregularities, please contact us",
  lb_consultas_sugerencias: "Inquiries and suggestions",
  lb_consultas_sugerencias_descripcion: "If you have any other questions, contact us through the form",
  lb_entrar: "Log in",
  lb_formulario_reclamaciones: "Claim form",
  lb_formulario_reclamaciones_info_1: "The data you provide will be used exclusively by EMT Palma for processing your claim",
  lb_formulario_reclamaciones_info_2: "Please provide as much detail as possible so we can process your claim properly and respond as quickly as possible",
  lb_formulario_reclamaciones_info_3: "By clicking the submit button, you confirm that you have read this privacy information:",
  lb_formulario_reclamaciones_info_4: "The data controller is Empresa Municipal de Transports Urbans de Palma S.A. (EMT). The purpose is to assess, process, and register your claim. You have the right to access, rectify, and delete your data, as well as other rights explained in our",
  lb_formulario_reclamaciones_info_5: "If you provide sensitive data (health, disability, etc.), you expressly consent to their processing for managing the claim and complying with legal obligations",
  lb_politica_privacidad: "Privacy Policy",
  lb_nombre: "First name",
  lb_apellido: "Last name",
  lb_telefono: "Phone number",
  lb_email: "Email",
  lb_direccion: "Address",
  lb_codigo_postal: "Postal code",
  lb_municipio: "City",
  lb_pais: "Country",
  lb_sentido_linea: "Line direction",
  lb_numero_bus: "Bus number",
  lb_matricula: "License plate",
  lb_lugar: "Location",
  lb_fecha: "Date",
  lb_hora: "Time",
  lb_titulo_transporte: "Transport ticket",
  lb_numero: "Number",
  lb_descripcion: "Description",
  lb_enviar: "Submit",
  lb_nombre_obligatorio: "First name is required",
  lb_apellido_obligatorio: "Last name is required",
  lb_documento_obligatorio: "ID number is required",
  lb_telefono_obligatorio: "Phone number is required",
  lb_email_invalido: "Invalid email",
  lb_email_obligatorio: "Email is required",
  lb_lugar_obligatorio: "Location is required",
  lb_fecha_obligatorio: "Date is required",
  lb_descripcion_obligatorio: "Description is required",
  lb_formulario_consultas: "Inquiry form",
  lb_mensaje_obligatorio: "Message",
  lb_mensaje: "Message is required",
  lb_municipio_obligatorio: "City is required",
  lb_titulo_transporte_obligatorio: "Transport ticket is required",
  lb_formulario_consultas_info_1: "Remember that most of the information you may need about our services is available on this website",
  lb_privacidad_title: "Privacy Policy",
  lb_lineas_no_hay_horarios_disponibles: 'No schedules available',
  lb_noticia_no_existe: 'This news no longer exists',
  lb_no_hay_avisos: 'No warnings',
  lb_consultas: "Consultations",
  lb_sugerencias: "Suggestions",

  lb_mas_detalles: 'Más detalles',
  lb_line_view_detail: 'Ver detalle línea',
  lb_alarm_program: 'Programar alarma',
  lb_alarm_bus_select_title: 'Crear alerta llegada bus',
  lb_alarm_bus_select_desc: 'Al activar la alerta de llegada del bus, recibirás una notificación con tiempo de antelación sobre la llegada de este.',
  lb_alarm_bus_option1: '2 minutos antes',
  lb_alarm_bus_option2: '5 minutos antes',
  lb_alarm_bus_option3: '8 minutos antes',
  lb_alarm_bus_select: 'Tiempo de antelación',
  lb_alarm_bus_notification_title: 'Llegada del bus',
  lb_alarm_next_bus: 'Activar alerta segundo bus',
  lb_formulario_enviado: 'Form submitted',
  lb_documento_no_valido: 'The document is not valid',

  lb_elija_una_opcion: 'Choose an option',
  lb_tarjeta_ciudadana: 'Citizen card',
  lb_billete: 'Ticket',
  lb_otros: 'Others',

  lb_campos_marcados_con: 'All fields marked with',
  lb_son_obligatorio: 'are mandatory.',

  lb_ingresa_captcha: 'Enter the captcha',

  lb_salida_refuerzo_desde:'Reinforcement departures:',
  lb_desde:'from',
  lb__desde:'from',
  lb_hasta:'to',
  lb_a: 'to',
  lb_volver: 'back',

  lb_ver_los: 'See the',
  lb_articulos: 'articles',

  lb_paradas_lineas_puntos: 'stops, lines, points of interest...',

  lb_todo:'All',

  lb_ver_todas_las: 'See all',
  lb_ver_todos_los: 'See all',
  lb_informacion_consejos_noticias: 'information, tips, news',
  lb_ver_todos_los_resultados: 'See all results',

  lb_segundo_bus_en: 'second bus in',

  lb_otra_informacion: 'Points of interest',
  lb_manana: 'morning',
  lb_tarde: 'afternoon',
  lb_frecuencia_media: 'Average frequency',

  lb_no_hay_resultados: 'No results found',
  lb_no_hay_resultados_para: 'No results for:',
  lb_lineas_y_paradas: 'lines and stops',

  lb_buscar_mas: 'Search more',
  lb_ver_more: 'See more',

  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  monthsAbrev: {
    1: 'Jan.',
    2: 'Feb.',
    3: 'Mar.',
    4: 'Apr.',
    5: 'May.',
    6: 'Jun.',
    7: 'Jul.',
    8: 'Aug.',
    9: 'Sept.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Dec.',
  },
  weekDays: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  },
  weekDaysAbrev: {
    0: 'Sun.',
    1: 'Mon.',
    2: 'Tue.',
    3: 'Wed.',
    4: 'Thu.',
    5: 'Fri.',
    6: 'Sat.',
  },
  lb_selecciona_un_icono: 'Select an icon',
  lb_mas_informacion: 'More information',

  lb_cookies_principal_body: 'EMTPalma usa las cookies esenciales, analíticas y de marketing para ofrecer, mantener y mejorar nuestros servicios y anuncios. Si estás de acuerdo, utilizaremos estos datos para la personalización de los anuncios y los análisis asociados.',
  lb_cookies_banner_title: 'Panel de aceptación Cookies',
  lb_cookies_banner_intro1: 'Este es el panel de configuración y aceptación de Cookies.',
  lb_cookies_banner_intro2: 'Selecciona las que deseas aceptar.',
  lb_cookies_banner_technic_title: 'Cookies técnicas',
  lb_cookies_banner_technic_desc: 'Estás cookies permiten controlar el tráfico y la comunicación de datos.',
  lb_cookies_banner_need: 'necesarias',
  lb_cookies_banner_view: 'Ver',
  lb_cookies_banner_hide: 'Ocultar',
  lb_cookies_banner_list_cookies: 'listado detallado de este tipo de cookies.',
  lb_cookies_banner_denomi: 'Denominación',
  lb_cookies_banner_origin: 'Origen',
  lb_cookies_banner_duration: 'Duración',
  lb_cookies_banner_purpose: 'Finalidad',
  lb_cookies_banner_persist: 'Persistente',
  lb_cookies_banner_technic_table_purpose1: 'Identifica si se ha realizado la aceptación de las cookies.',
  lb_cookies_banner_technic_table_purpose2: 'Identifica el último idioma seleccionado por el usuario.',
  lb_cookies_banner_analytics_title: 'Aceptar cookies analíticas',
  lb_cookies_banner_analytics_desc: 'Estas cookies recogen datos sobre el comportamiento de los usuarios y permiten elaborar un perfil de usuario. Google Analytics',
  lb_cookies_banner_analytics_table_purpose1: 'Persistente, dos años a partir de la configuración o actualización.',
  lb_cookies_banner_analytics_table_purpose1_desc: 'Se usa para distinguir a los usuarios.',
  lb_cookies_banner_analytics_table_purpose2_duration: 'Persistente, finaliza al terminar la sesión.',
  lb_cookies_banner_analytics_table_purpose2: 'Incluye información de la campaña relativa al usuario. Si has vinculado tus cuentas de Google Analytics y AdWords, las etiquetas de conversión de sitios web leerán esta cookie, a menos que la inhabilites.',
  lb_cookies_banner_accept_all: 'Aceptar todas',
  lb_cookies_banner_accept_select: 'Aceptar seleccionadas',

  lb_privacidad_body: `
  <div class="contenidoGeneral">
  <p>Last modified: November 2023</p>

  <p>This privacy policy applies to this website (hereinafter referred to as the Website).</p>

  <p>Please read it carefully. It contains important information about the processing of your personal data and the rights granted to you under current regulations in this area.</p>

  <p>We reserve the right to update our privacy policy at any time due to business decisions, as well as to comply with possible legislative or jurisprudential changes. If you have any doubts or need any clarification regarding our Privacy Policy or your rights, you can contact us through the channels indicated below.</p>

  <p>You declare that the data you provide us, now or in the future, is correct and truthful, and you commit to notifying us of any changes to the same. In the event of providing personal data of third parties, you commit to obtaining the prior consent of the affected parties and informing them about the content of this policy.</p>

  <p>Generally, the fields in our forms marked as mandatory must be filled in to process your requests.</p>

  <ul>
    <li><strong>Who is responsible for processing your data?</strong><br> Unless otherwise indicated, the data controller for the data collected on this Website is the Municipal Transport Company of Palma, S.A. (hereinafter EMT) with registered office at Calle Josep Anselm Clavé nº5, 07002 Palma (Balearic Islands); Tel. 971 21 44 44; DPO: <a href="mailto:privacidad@emt.palma.cat" target="">privacidad@emt.palma.cat</a></li> <br>
    <li><strong>What personal information do we collect?</strong><br> The data we process is obtained from:
      <ul>
        <li>The forms you fill out and the requests you make on the Website. We also process data included in requests and inquiries we receive by email.</li>
        <li>Profiles and analytics obtained from the browsing of Website users.</li>
      </ul> <br>
    The categories of data we typically process consist of:
      <ul>
        <li>Identifying and contact data, including transport title, ID card or passport;</li>
        <li>Data on personal characteristics, such as language and nationality;</li>
        <li>Data related to your browsing, for example, the IP address from which you connect to the Website, web logs, pages visited, or actions taken on the Website. For this, we use cookies and similar technologies that may involve tracking your browsing. More information in our Cookie Policy.</li>
        <li>Other types of data included by users in their inquiries, comments, or complaints.</li>
      </ul>
    </li> <br>
    <li><strong>What will we use your data for?</strong><br> The data of our users will be processed for managing the relationship with them, responding to their requests and inquiries, providing our services, administering and managing the security of the website, and fulfilling our legal obligations. This data will also be processed for analytical purposes and quality improvement.<br> The inclusion of personal data related to your health in complaints or claims necessarily implies your consent for the processing of such data for the attention to the aforementioned claim.</li> <br>
    <li><strong>To whom can we communicate your data?</strong><br> Your data will only be communicated to third parties due to legal obligation, with your consent, or when your request implies such communication.<br> Furthermore, you are informed that, when circumstances related to the processing of a complaint or claim require it, the recipients of the personal information may include, among others, public administrations or entities, official bodies, lawyers, judges and courts, or insurance entities.</li> <br>
    <li><strong>Legal basis for processing</strong><br> The basis for processing your data is the management of the legal relationship established with you, the provision of requested services, and compliance with legal obligations, especially applicable accounting and tax regulations.<br> The following processes are based on the existence of a legitimate interest:
      <ul>
        <li>The management of website security is based on our legitimate interest in ensuring the security of our systems.</li>
        <li>The performance of statistics and quality control is based on our legitimate interest in evaluating our services.</li>
      </ul> <br>
    The following processes are based on your consent, without the withdrawal of this consent affecting the provision of contracted services:
      <ul>
        <li>The performance of browsing profiles based on information obtained from cookies or similar technologies.</li>
      </ul>
    </li> <br>
    <li><strong>How long will we keep your data?</strong><br> In general, we keep your data during the duration of the relationship you maintain with us and, in any case, during the periods established in applicable legal provisions and for as long as necessary to address potential responsibilities arising from processing. We will delete your data when they are no longer necessary or relevant for the purposes for which they were collected. Access logs to restricted areas of the website will be deleted one month after their creation. The information related to browsing will be deleted once the web connection has ended and statistics have been made.</li> <br>
    <li><strong>What are your rights?</strong><br> You have the right to obtain confirmation of whether we are processing your personal data and, if so, to access it. You can also request that your data be rectified when inaccurate or that incomplete data be completed, as well as request their deletion when, among other reasons, the data are no longer necessary for the purposes for which they were collected.<br> In certain circumstances, you may request the limitation of the processing of your data. In such cases, we will only process the affected data for the formulation, exercise, or defense of claims or to protect the rights of others. In certain conditions and for reasons related to your particular situation, you may also object to the processing of your data. In this case, we will cease processing the data unless there are compelling legitimate grounds that prevail over your interests or rights and freedoms, or for the formulation, exercise, or defense of claims.<br> <br> Likewise, and under certain conditions, you may request the portability of your data to be transferred to another data controller.<br> <br> You can revoke the consent you have given for certain purposes without affecting the legality of the processing based on consent prior to its withdrawal.<br> You also have the right to file a complaint with a data protection authority.<br> <br> To exercise your rights, you must send a request accompanied by a copy of your national identity document, or another valid document that identifies you by postal or electronic mail, to our Data Protection Officer at the addresses indicated in the section Who is responsible for processing your data?<br> <br> You can obtain more information about your rights and how to exercise them on the website of the Spanish Data Protection Agency at <a href="http://www.aepd.es" target="_blank"> <u>www.aepd.es</u></a></li>
  </ul>
  <p>&nbsp;</p>
  <p>8.&nbsp;&nbsp;<strong>Information for users about the privacy policy linked to the subsidy for free bus service at EMT Palma during 2023</strong></p>
  <p>Public transport users, customers, and potential customers are informed about the personal data that may be collected, as established in the granting of a nominative subsidy to the Autonomous Community of the Balearic Islands for the establishment of a 100% discount on the price of transport subscriptions and multi-trip tickets for collective terrestrial public transport in the Balearic Islands from the Ministry of Transport, Mobility and Urban Agenda for the year 2023. Specifically, the following may be collected: the subscription identifier, the ID of the subscription user, the duration, the route or area covered, and the date of issue. For multi-trip tickets: the title identifier, the route or territorial application area corresponding to the title, the number of trips included in the title, and the date of issue, which will be made available to the Ministry of Transport, Mobility and Urban Agenda of the Government of Spain, with the aim of verifying compliance with the objectives pursued with the granting of this subsidy and the justification of its application. Likewise, public transport users, customers, and potential customers are informed of the possibility of exercising the rights: access, rectification, deletion, limitation of processing, obligation of notification relating to rectification or deletion, portability, opposition, limitation of processing, not to be subject to automated individual decisions, recognized in Articles 15 to 22 of Regulation (EU) 2016/679, as well as in Organic Law 3/2018, of December 5, on Personal Data Protection and Guarantee of Digital Rights, by addressing the Ministry of Transport, Mobility and Urban Agenda, Paseo de la Castellana, 67, 28071-Madrid or by email dirgtt@mitma.es</p>
  </div>`,
  lb_aviso_legal_body:`
    <div class="contenidoGeneral">
    <h1>LEGAL NOTICE AND WEBSITE TERMS OF USE</h1>

    <p>&nbsp;</p>

    <p>Accessing this website assigns the condition of USER and implies full and unreserved acceptance, from this access and/or use, of this legal notice and the privacy policy in its latest version. Therefore, we recommend reading these documents before using the functionalities offered by this website, as well as each time you access it, since we reserve the right to change, modify, add, or remove any part of these conditions at any time.</p>

    <p>Simple access to this website does not, in any case, imply the existence of a commercial relationship between the user and the website.</p>

    <p>&nbsp;</p>

    <p><b>I. WEBSITE OWNER</b></p>

    <p>In compliance with Article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce, the following information about the owner of this website is provided:</p>

    <ul>
      <li><b>Website Owner:</b> Empresa Municipal de Transports Urbans de Palma, S.A. (hereinafter, <b>EMT</b>).</li>
      <li><b>Registered Office:</b> Carrer Josep Anselm Clavé nº5, 07002 Palma (Illes Balears)</li>
      <li><b>C.I.F.:</b> A07152515</li>
      <li><b>Registration Details:</b> Registered in the Mercantile Registry of Palma, Volume 534, Book 45, Folio 70, Section, Page PM8833, Entry 17</li>
    </ul>

    <p>In addition to the registered office, the following channels are available to users for submitting requests, questions, or complaints:</p>

    <ul>
      <li>Contact form on the website</li>
      <li>Email: usuaris@emt.palma.es</li>
      <li>Phone: 971 214 444</li>
    </ul>

    <p>&nbsp;</p>

    <p><b>II. TERMS OF USE</b></p>

    <p><b>1. Introduction.</b> <b>EMT</b> provides information on this website about the urban collective transport network in the municipality of Palma. By accessing and using this website, you agree to comply with the terms set out below, so we recommend reading this section carefully before starting your navigation.</p>

    <p><b>2. User Obligations.</b> Users agree to use this website lawfully, in accordance with these terms and in a way that does not harm the rights or interests of <b>EMT</b> or third parties. By way of example, and not exhaustive or exclusive, the User also agrees to:</p>

    <ul>
      <li>Not engage in illegal activities or activities contrary to public order or good faith;</li>
      <li>Not use the data published on the website to send unsolicited communications (spam).</li>
      <li>Not introduce or disseminate false, misleading, ambiguous, or inaccurate information or content on the website in a way that could mislead recipients, nor disseminate racist, xenophobic, pornographic, pro-terrorism content, or content violating human or children's rights;</li>
      <li>Not perform actions that infringe the intellectual property rights of <b>EMT</b> or third parties;</li>
      <li>Not cause damage to the physical and logical systems of <b>EMT</b>, its suppliers, or third parties;</li>
      <li>Not introduce or spread computer viruses or use any other physical or logical systems that may cause the aforementioned damage.</li>
      <li>Not remove, alter, bypass, or manipulate any protection devices or security systems installed on the pages of this website.</li>
    </ul>

    <p><b>3. Exclusion of Liability.</b> This website is provided "as is," and its use is at the User's own risk. Therefore, neither <b>EMT</b> nor its administrators, employees, suppliers, or collaborators will be liable for damages of any kind, direct or indirect, arising from the use of the website, expressly excluding <b>EMT</b>, to the fullest extent permitted by law, from any type of warranties, whether express or implied.</p>

    <p><b>EMT</b> does not guarantee the availability and accessibility of the website but will make all reasonable efforts in this regard. Occasionally, interruptions may occur for the necessary time to perform corresponding maintenance operations.</p>

    <p><b>EMT</b> is not responsible for potential damages caused by interferences, interruptions, computer viruses, telephone breakdowns, or disconnections caused by reasons beyond its control; delays or blockages in the electronic system due to deficiencies or overloads in the data processing center, telephone lines, Internet system, or other electrical systems; nor for any other alteration that may occur in the User's Software or Hardware. It also does not guarantee the absence of viruses, malicious code (malware), trojans, or other elements that may cause alterations in the User's computer system, documents, or files, excluding any liability for damages of any kind caused to the User for this reason. Likewise, <b>EMT</b> will not be liable for damages caused by third parties through illegal intrusions beyond its control.</p>

    <p>Nor will it be responsible for damages caused by the use or misuse of the website content or the consequences that may arise from errors, defects, or omissions in the content that may appear on this website provided by Users or third parties. <b>EMT</b> does not assume any obligation or responsibility concerning services not directly provided.</p>

    <p><b>4. External Links.</b> <b>EMT</b> will not, under any circumstances, assume any responsibility for the content of links belonging to third-party websites, nor will it guarantee the technical availability, quality, reliability, accuracy, completeness, truthfulness, validity, or legality of any material or information contained in any such hyperlinks or other Internet sites. Likewise, the inclusion of these external links does not imply any association, merger, or participation with the connected entities.</p>

    <p><b>5. Processing of Personal Data.</b> Users consent to the processing of their personal data to the extent and under the terms indicated in our privacy policy, available on the website's homepage, which is also incorporated into these terms by reference. In this policy, users will find information on how to exercise their rights of access, deletion, restriction, and correction of their personal information, as well as opposition to processing and portability.</p>

    <p><b>6. Intellectual Property and Copyright.</b> Without prejudice to content over which third parties hold intellectual property rights, the intellectual property rights of the website, domain name, source code, design, navigation structure, and elements contained therein (e.g., images, sound, audio, video, software, or texts; trademarks or logos, color combinations, structure and design, etc.) belong to <b>EMT</b>, which has the exclusive rights to exploit them in any form, and particularly the rights of reproduction, distribution, public communication, and transformation, as provided by the current Intellectual Property Law. Reproduction, distribution, and public communication, including making available all or part of the content of this website on any medium or by any technical means, without the authorization of <b>EMT</b> or, where applicable, the third parties holding intellectual property or copyright over the affected content, are expressly prohibited. However, the website user may view the elements of this website and even print, copy, and store them on their computer's hard drive or any other physical medium, provided it is solely for their personal and private use. Entities or individuals who, with prior authorization from the website owner, intend to establish a link to it must ensure that it only allows access to this website or service without reproducing its content and services.</p>

    <p><b>7. Nullity of Clauses.</b> If any clause of these terms of use is declared null, it will only affect that provision or the part that has been so declared, with the rest of the terms remaining in effect, and the provision or affected part considered not included.</p>

    <p><b>8. Acceptance.</b> Accessing and using the website necessarily implies that all the terms of use are expressly accepted by you.</p>

    <p><b>9. Applicable Law and Jurisdiction.</b> This website is governed by Spanish law, excluding its conflict-of-law rules, and any disputes arising from its use or the associated services will be submitted to the jurisdiction of the Courts and Tribunals that are competent under applicable regulations.</p>

    <p>The European Commission provides an online dispute resolution platform for consumers, which can be accessed through the following link: <a href="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.chooseLanguage">https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.chooseLanguage</a></p>

    <p>&nbsp;</p>

    <p>Version 1.0 – January 2021</p>
    </div>
  `,
  lb_politica_cookies_body:`
  <div class="contenidoGeneral">
      <h1>COOKIE POLICY</h1>

      <p><u><b>WHAT ARE COOKIES?</b></u></p>
      <p>This website uses cookies and/or similar technologies that store and retrieve information while you browse. In general, these technologies can serve various purposes, such as recognizing you as a user, obtaining information about your browsing habits, or personalizing the way content is displayed.</p>
      <p>There are cookies that are controlled and managed by the website owner (these are called "first-party cookies") and others that are controlled by third parties (these are known as "third-party cookies"), for example, because they provide a tool or functionality integrated into the website.</p>
      <p>The specific uses we make of these technologies are described below.</p>

      <p><u><b>WHAT TYPES OF COOKIES DO WE USE AND FOR WHAT PURPOSE?</b></u></p>
      <p>On this website, we use the following types of cookies:</p>

      <ol>
          <li>
              <b>Technical or essential cookies for providing services:</b>
              <p>These are the cookies that allow the user to navigate through a website, platform, or application and use the various options or services available, including those used to enable the management and operation of the website and activate its functions and services...</p>
              <ul>
                  <li>
                      FACEBOOK: <a href="https://www.facebook.com/policies/cookies/" target="_blank">https://www.facebook.com/policies/cookies/</a>
                  </li>
                  <li>
                      TWITTER: <a href="https://help.twitter.com/en/rules-and-policies/twitter-cookies" target="_blank">https://help.twitter.com/en/rules-and-policies/twitter-cookies</a>
                  </li>
              </ul>
          </li>
          <li>
              <b>Preference or personalization cookies:</b>
              <p>We use first-party cookies that allow us to remember information so the user can access the service with specific features...</p>
              <ul>
                  <li>
                      To accept or reject the use of these cookies, you can use the <a href="javascript:CookieScript.instance.show()">cookie configuration panel</a>.
                  </li>
              </ul>
          </li>
          <li>
              <b>Analytics or measurement cookies:</b>
              <p>We use third-party cookies that allow us to quantify the number of users and perform statistical analysis...</p>
              <ul>
                  <li>
                      You can consult the list of third parties that process the information collected by these cookies in the "Third-Party Cookies" section.
                  </li>
                  <li>
                      To accept or reject the use of these cookies, you can use the <a href="javascript:CookieScript.instance.show()">cookie configuration panel</a>.
                  </li>
              </ul>
          </li>
          <li>
              <b>Behavioral advertising cookies:</b>
              <p>We also use third-party cookies that allow us to analyze users' browsing habits to create specific profiles...</p>
              <ul>
                  <li>
                      You can consult the list of third parties that process the information obtained with these cookies in the "Third-Party Cookies" section.
                  </li>
                  <li>
                      To accept or reject the use of these cookies, you can use the <a href="javascript:CookieScript.instance.show()">cookie configuration panel</a>.
                  </li>
              </ul>
          </li>
      </ol>

      <p><u><b>DATA TRANSFERS TO THIRD COUNTRIES</b></u></p>
      <p>You can find information about data transfers to third countries, if any, made by the third parties identified in this cookie policy in their respective policies.</p>

      <p><u><b>DATA RETENTION PERIOD</b></u></p>
      <p>Some cookies are deleted once you finish browsing the website (session cookies), while others may remain stored on the users' devices and be accessed for a longer period (persistent cookies).</p>
      <ul>
          <li>First-party preference or personalization cookies: Retained for one year.</li>
          <li>Third-party cookies expiration: You can find information about the retention periods in their policies.</li>
      </ul>

      <p><u><b>PERSONAL DATA PROCESSING AND USER RIGHTS</b></u></p>
      <p>The installation of third-party cookies may involve the collection of personal browsing data...</p>

      <p><u><b>HOW CAN I MANAGE COOKIES?</b></u></p>
      <p>You can manage cookies through the cookie configuration panel or through your browser settings:</p>
      <ul>
          <li><a href="javascript:CookieScript.instance.show()">Cookie configuration panel</a></li>
          <li>Browser settings: You can allow or block cookies...</li>
      </ul>

      <p><u><b>THIRD-PARTY COOKIES</b></u></p>

      <!-- Responsive Table -->
      <div style="overflow-x: auto;">
          <table border="1" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 100%; text-align: center;">
              <thead>
                  <tr>
                      <th>TYPE OF COOKIES</th>
                      <th>COOKIES</th>
                      <th>RESPONSIBLE</th>
                      <th>+ INFO</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>Analytics or measurement</td>
                      <td>GOOGLE ANALYTICS</td>
                      <td>Google, Inc.<br>1600 Amphitheatre Parkway, Mountain View, CA 94043. USA</td>
                      <td>
                          <p>More information:</p>
                          <a href="https://support.google.com/analytics/answer/6004245">https://support.google.com/analytics/answer/6004245</a>
                          <a href="http://www.google.com/intl/en/policies/privacy/">http://www.google.com/intl/en/policies/privacy/</a>
                      </td>
                  </tr>
                  <tr>
                      <td>Analytics or measurement</td>
                      <td>JSESSIONID</td>
                      <td>Adobe Systems Software Ireland Limited<br>6 Riverwalk, Naas Road, Dublin 24, Ireland</td>
                      <td>
                          <p>More information:</p>
                          <a href="https://www.adobe.com/en/privacy/cookies.html">https://www.adobe.com/en/privacy/cookies.html</a>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
  `
};
